(function() {
  var $dce088a9af95ce96$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("text-overflow-toggle")) customElements.define("text-overflow-toggle", class extends HTMLElement {
      static observedAttributes=[ "disabled" ];
      #input;
      #content;
      #label;
      #observer;
      #raf;
      #timer;
      #transitionTimeout;
      #overflowing=false;
      constructor() {
        super();
        this.#input = this.querySelector('input[type="checkbox"]');
        this.#content = this.#input?.nextElementSibling;
        this.#label = this.querySelector(`label[for="${this.#input?.id}"]`);
      }
      connectedCallback() {
        if (!this.#input || !this.#content || !this.#label) return;
        if (!getComputedStyle(this.#content).transition.includes("max-height")) this.#content.style.transition = "max-height 300ms ease-out";
        if (!this.#input.checked) this.#content.classList.add("line-clamp-2");
        this.#input.addEventListener("change", () => this.#toggle());
        this.#updateLabel();
        this.#observe();
        this.#check();
      }
      disconnectedCallback() {
        this.#observer?.disconnect();
        this.#raf && cancelAnimationFrame(this.#raf);
        this.#timer && clearTimeout(this.#timer);
        this.#transitionTimeout && clearTimeout(this.#transitionTimeout);
      }
      attributeChangedCallback() {
        this.#updateLabel();
      }
      #check() {
        this.#raf && cancelAnimationFrame(this.#raf);
        this.#raf = requestAnimationFrame(() => {
          const wasOverflowing = this.#overflowing;
          this.#overflowing = this.#content.scrollHeight > this.#content.clientHeight;
          if (wasOverflowing !== this.#overflowing) {
            this.#updateLabel();
            if (!this.#overflowing && this.#input.checked) {
              this.#input.checked = false;
              this.#toggle();
            }
          }
        });
      }
      #updateLabel() {
        const show = this.#overflowing && !this.hasAttribute("disabled");
        Object.assign(this.#label.style, {
          opacity: show ? "1" : "0",
          pointerEvents: show ? "auto" : "none"
        });
        this.#input.disabled = this.hasAttribute("disabled");
      }
      #toggle() {
        const expanding = this.#input.checked;
        if (this.#transitionTimeout) clearTimeout(this.#transitionTimeout);
        if (expanding) this.#content.classList.remove("line-clamp-2");
        const height = this.#content.scrollHeight;
        const duration = Math.min(600, Math.max(200, Math.sqrt(height) * 10));
        Object.assign(this.#content.style, {
          transitionDuration: `${duration}ms`,
          maxHeight: expanding ? `${height}px` : ""
        });
        if (!expanding) this.#transitionTimeout = setTimeout(() => {
          if (!this.#input.checked) this.#content.classList.add("line-clamp-2");
        }, duration);
        this.dispatchEvent(new CustomEvent("toggle", {
          detail: {
            expanded: expanding,
            height: height
          },
          bubbles: true
        }));
      }
      #observe() {
        let lastWidth = this.#content.offsetWidth;
        this.#observer = new ResizeObserver(() => {
          this.#timer && clearTimeout(this.#timer);
          this.#timer = setTimeout(() => {
            const newWidth = this.#content.offsetWidth;
            if (Math.abs(newWidth - lastWidth) > 1) {
              lastWidth = newWidth;
              this.#check();
            }
          }, 16);
        });
        this.#observer.observe(this.#content);
      }
      toggle(expanded) {
        if (!this.hasAttribute("disabled")) {
          this.#input.checked = expanded ?? !this.#input.checked;
          this.#toggle();
        }
      }
      get expanded() {
        return this.#input.checked;
      }
      get overflowing() {
        return this.#overflowing;
      }
    });
  })();
})();